import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { SET_LLAVES_DE_PREDIOS } from 'store/reducers/catalogs';
import { store } from 'store';
import { getTiposDeLlavesDePredios } from 'api/catastro/index';

export const baseURI = 'catastro/configuracion-de-la-clave/';

/**
 * GET Llaves de Predio
 * @returns {Promise<Array<object>>}
 */
export const getLlavesDePredio = async (params = null, config) => {
  try {
    await getTiposDeLlavesDePredios();
    const response = await API.get(baseURI, { params, ...config });
    store.dispatch({
      type: SET_LLAVES_DE_PREDIOS,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Llave de Predio
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getLlaveDePredio = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Llave de Predio
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLlaveDePredio = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Llave de Predio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLlaveDePredio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Llave de Predio
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteLlaveDePredio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
